<ul class="pagination w-100" *ngIf="pagesVisible.length > 1">
  <li
    class="page-item first"
    [ngClass]="{'disabled': !meta.hasPrevious || isFirstPageVisible}"
    test-id="pagination.first"
  >
    <a class="page-link cursor-pointer" (click)="pageSelected.next(1)">
      <i class="first"></i>
    </a>
  </li>

  <li
    class="page-item previous"
    [ngClass]="{'disabled': !meta.hasPrevious}"
    test-id="pagination.prev"
  >
    <a class="page-link cursor-pointer" (click)="pageSelected.next(currentPage - 1)">
      <i class="previous"></i>
    </a>
  </li>

  <li
    *ngFor="let pageNumber of pagesVisible"
    class="page-item cursor-pointer"
    [class.active]="currentPage === pageNumber"
  >
    <a class="page-link" (click)="pageSelected.next(pageNumber);">
      {{pageNumber}}
    </a>
  </li>

  <li
    class="page-item next"
    [ngClass]="{'disabled': !meta.hasNext}"
    test-id="pagination.next"
  >
    <a class="page-link cursor-pointer" (click)="pageSelected.next(currentPage + 1)">
      <i class="next"></i>
    </a>
  </li>

  <li
    class="page-item last"
    [ngClass]="{'disabled': !meta.hasNext || isLastPageVisible}"
    test-id="pagination.last"
  >
    <a class="page-link cursor-pointer" (click)="pageSelected.next(lastPage)">
      <i class="last"></i>
    </a>
  </li>
</ul>
